import { createSelector } from 'reselect';

// Config
import {
  getCollectorDetailsSelector,
  getCutOffTimeSelector,
  getGiftMessageLinesSelector,
  getClickAndCollectProceedingToPaymentSelector,
  getSelectedCollectionPointSelector,
  getShowCutOffPassedModalSelector,
  getSuggestedNewCollectionDateSelector,
} from '@redux/reducers/click-and-collect/clickAndCollectSelector';

const clickAndCollectCutOffPassedModalState = createSelector(
  [
    getCollectorDetailsSelector,
    getCutOffTimeSelector,
    getGiftMessageLinesSelector,
    getClickAndCollectProceedingToPaymentSelector,
    getSelectedCollectionPointSelector,
    getShowCutOffPassedModalSelector,
    getSuggestedNewCollectionDateSelector,
  ],
  (
    collectorDetails,
    cutOffTime,
    giftMessageLines,
    proceedingToPayment,
    selectedCollectionPoint,
    showModal,
    suggestedNewCollectionDate,
  ) => ({
    collectorDetails,
    cutOffTime,
    giftMessageLines,
    proceedingToPayment,
    selectedCollectionPoint,
    showModal,
    suggestedNewCollectionDate,
  }),
);

export default clickAndCollectCutOffPassedModalState;
